import { Outlet } from "react-router-dom"
const MainOthers = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainOthers;